export default [{
    header: 'Blog',
    icon: 'LayoutIcon',
    children: [{
        title: 'Lista',
        route: 'blogs',
        icon: 'ListIcon'
    }, {
        title: 'Agregar',
        route: 'blogs-create',
        icon: 'MousePointerIcon'
    }]
}];
